// extracted by mini-css-extract-plugin
export default {"footer":"components-payment-modal-pay-balance-module__footer"};